import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";

// Salesforce redirects the OAuth popup here (a real SPA route, so it always matches
// regardless of how /api is routed in production). We then complete the token
// exchange via an authenticated XHR to the backend, notify the opener, and close.
export default function SalesforceOAuthCallback() {
    const [status, setStatus] = useState("working"); // working | connected | error
    const [message, setMessage] = useState("Finishing Salesforce connection…");

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");
        const state = params.get("state");
        const err = params.get("error_description") || params.get("error");

        const notify = (s) => {
            try { if (window.opener) window.opener.postMessage({ source: "inspiro-sf", status: s }, "*"); } catch (_) {}
        };

        const finish = (s, msg, autoClose) => {
            setStatus(s);
            setMessage(msg);
            notify(s);
            if (autoClose) setTimeout(() => { try { window.close(); } catch (_) {} }, s === "connected" ? 1200 : 4000);
        };

        if (err || !code || !state) {
            finish("error", err || "Authorization was cancelled.", true);
            return;
        }
        (async () => {
            try {
                await api.post("/integrations/salesforce/oauth/exchange", { code, state });
                finish("connected", "Your Salesforce org is now connected to Inspiro Connect.", true);
            } catch (e) {
                finish("error", formatApiError(e.response?.data?.detail) || "Token exchange failed. Check your Consumer Secret and callback URL.", true);
            }
        })();
    }, []);

    const connected = status === "connected";
    const working = status === "working";
    const color = connected ? "#16a34a" : working ? "#57534e" : "#dc2626";
    const icon = connected ? "✓" : working ? "…" : "✕";
    const title = connected ? "Salesforce Connected" : working ? "Connecting…" : "Connection Failed";

    return (
        <div style={{ fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif", background: "#faf9f7", display: "grid", placeItems: "center", height: "100vh", margin: 0, color: "#1c1917" }} data-testid="sf-oauth-callback">
            <div style={{ textAlign: "center", maxWidth: 360, padding: 32 }}>
                <div style={{ width: 56, height: 56, borderRadius: "50%", display: "grid", placeItems: "center", margin: "0 auto 16px", background: `${color}1a`, color, fontSize: 26, fontWeight: 700 }} data-testid="sf-oauth-status">{icon}</div>
                <h1 style={{ fontSize: 18, margin: "0 0 8px" }}>{title}</h1>
                <p style={{ fontSize: 13, color: "#57534e", margin: "0 0 18px", lineHeight: 1.5 }}>{message}</p>
                {!working && (
                    <button onClick={() => { try { window.close(); } catch (_) {} }} style={{ background: "#1c1917", color: "#fff", border: 0, borderRadius: 999, padding: "10px 22px", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>Close window</button>
                )}
            </div>
        </div>
    );
}
